export const constants = {
  FAVOURABLE: 'Favorable',
  UNFAVOURABLE: 'Unfavorable',
  NEUTRAL: 'Neutral',
};
